export const getVirtualsState = state => state.virtuals;
